var React = require('react');

function NaviBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M480-360 280-560h400L480-360Z"}));
}

NaviBottom.defaultProps = {"height":"24px","viewBox":"0 -960 960 960","width":"24px","fill":"#e3e3e3"};

module.exports = NaviBottom;

NaviBottom.default = NaviBottom;
